<template>
  <div>
    <handle-assign-stock-sidebar ref="assignStockSidebar" />

    <div class="flex justify-between">
      <div class="flex justify-between">
        <venue-selector
          v-model="filterVenue"
          @venue="onVenueSelected"
          style="width: 350px"
          :filterCountries="[activeCountry.name]"
          :globalMode="true"
          :multiple="false"
        />
      </div>
      <div class="flex justify-end">
        <vs-button
          @click="onClickCreateNew"
          :disabled="isLoading"
          icon="add"
          class="mr-3"
          type="relief"
          color="primary"
          >Assign stock to venue</vs-button
        >
      </div>
    </div>

    <!-- table -->
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        v-if="!isLoading"
        ref="table"
        class="mt-4"
        search
        pagination
        max-items="8"
        :data="filteredVenueProducts"
      >
        <template slot="header">
          <div class="flex mb-2">
            <vs-select
              v-model="filters.mandatoryStatus"
              placeholder="Filter by mandatory"
            >
              <vs-select-item
                :key="item.value"
                :value="item.value"
                :text="item.text"
                v-for="item in selectableFilters.mandatoryStatus"
              />
            </vs-select>

            <vs-select
              v-model="filters.delistedStatus"
              placeholder="Filter by delisted"
              class="ml-2"
            >
              <vs-select-item
                :key="item.value"
                :value="item.value"
                :text="item.text"
                v-for="item in selectableFilters.delistedStatus"
              />
            </vs-select>
          </div>
          <vs-spacer />
        </template>

        <template slot="thead" v-if="!isLoading">
          <vs-th sort-key="stockProductId">Product id</vs-th>
          <vs-th sort-key="displayName">Name</vs-th>
          <vs-th sort-key="isMandatory">Is mandatory</vs-th>
          <vs-th sort-key="isDelisted">Is delisted</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div
                  class="product-name font-medium truncate flex flex-row items-center"
                >
                  <img width="40" :src="ProductIcon" />
                  <p class="ml-4">{{ tr.stockProductId.id }}</p>
                </div>
              </vs-td>
              <vs-td>
                <div>
                  {{ tr.displayName }}
                </div>
              </vs-td>
              <vs-td>
                <vs-chip>
                  {{ tr.isMandatory | yesno }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <vs-chip :color="!tr.isDelisted | yesnocolor">
                  {{ tr.isDelisted | yesno }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <div class="ml-4 flex">
                  <vs-tooltip
                    text="Click to delist product"
                    v-if="!tr.isDelisted"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current"
                      @click.stop="confirmDelist(tr)"
                    />
                  </vs-tooltip>
                  <vs-tooltip text="Click to re-list product" v-else>
                    <feather-icon
                      icon="RefreshCcwIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current"
                      @click.stop="confirmRelist(tr)"
                    />
                  </vs-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <div
        v-if="isLoading"
        class="mt-10 my-auto vx-col flex items-center align-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-2/4 xl:w-2/4 mx-auto text-center"
      >
        <img
          src="@/assets/images/no_venue_selected.png"
          alt="graphic-404"
          class="mx-auto mb-4"
          style="width: 150px"
        />
        <h5 class="sm:mx-0 mx-4 mt-4 text-xl d-theme-text">
          Select a venue to continue
        </h5>
        <!-- <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text">
            Select a venue to continue
          </p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/product-icon.png";
import VenueSelector from "@/components/VenueSelector.vue";
import HandleAssignStockSidebar from "./HandleAssignStockSidebar.vue";

export default {
  components: { VenueSelector, HandleAssignStockSidebar },
  data() {
    return {
      filterVenue: null,
      currentVenue: null,
      isLoading: true,
      ProductIcon,

      filters: {
        mandatoryStatus: null,
        delistedStatus: null,
      },

      selectableFilters: {
        mandatoryStatus: [
          { text: "All", value: 0 },
          { text: "Mandatory", value: 1 },
          { text: "Optional", value: 2 },
        ],
        delistedStatus: [
          { text: "All", value: 0 },
          { text: "Delisted", value: 1 },
          { text: "Not delisted", value: 2 },
        ],
      },
    };
  },
  methods: {
    async onVenueSelected(venue) {
      console.log("Selected venue", venue);
      if (!venue) {
        this.currentVenue = null;
        this.isLoading = true;
        return;
      }
      this.currentVenue = venue;
      this.isLoading = true;
      await this.$store.dispatch(
        "pimVenues/getVenue",
        this.currentVenue.venueId
      );
      this.isLoading = false;
    },
    onClickCreateNew() {
      this.$refs.assignStockSidebar.showEmpty(this.currentVenue.venueId);
    },

    confirmRelist(product) {
      this.$vs.dialog({
        type: "confirm",
        title: "Relist product",
        text: "Are you sure you want to re-list this product on the venue?",
        accept: () => this.relistProduct(product),
      });
    },
    relistProduct(product) {
      console.log("Relisting product", product);
      this.$store
        .dispatch("pimVenues/relistAssignedStockProducts", {
          venueId: this.currentVenue.venueId,
          dto: {
            stockProductIds: [product.stockProductId.id],
          },
        })
        .then(async () => {
          this.$vs.notify({
            title: "Success",
            text: "Product re-listed to the venue",
          });

          await this.$store.dispatch(
            "pimVenues/getVenue",
            this.currentVenue.venueId
          );
        })
        .catch((error) => {
          console.error("Error re-listing", error);
          this.$vs.notify({
            title: "Error relisting",
            text: "Could not re-list product to the venue",
            color: "danger",
          });
        });
    },

    confirmDelist(product) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Delist product",
        text: "Are you sure you want to delist this product from the venue?",
        accept: () => this.delistProduct(product),
      });
    },
    delistProduct(product) {
      console.log("Delisting product", product);
      this.$store
        .dispatch("pimVenues/delistAssignedStockProducts", {
          venueId: this.currentVenue.venueId,
          dto: {
            stockProductIds: [product.stockProductId.id],
          },
        })
        .then(async () => {
          this.$vs.notify({
            title: "Success",
            text: "Product delisted from the venue",
          });

          await this.$store.dispatch(
            "pimVenues/getVenue",
            this.currentVenue.venueId
          );
        })
        .catch((error) => {
          console.error("Error delisting", error);
          this.$vs.notify({
            title: "Error delisting",
            text: "Could not delist product from the venue",
            color: "danger",
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      venueAllProducts: "pimVenues/venueAllProducts",
      activeCountry: "venues/activeCountry",
    }),

    filteredVenueProducts() {
      return this.venueAllProducts.filter((e) => {
        switch (this.filters.mandatoryStatus) {
          case 1:
            if (!e.isMandatory) return false;
            break;
          case 2:
            if (e.isMandatory) return false;
            break;
        }
        switch (this.filters.delistedStatus) {
          case 1:
            if (!e.isDelisted) return false;
            break;
          case 2:
            if (e.isDelisted) return false;
            break;
        }

        return true;
      });
    },
  },

  async created() {},
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
  }
}
</style>
